document.addEventListener('DOMContentLoaded', function () {

  const previewArea = document.getElementById('preview-area');
  if (!previewArea) return;

  const renderPreview = () => {

    console.log("Rendering preview.")

    // Produkte aus localStorage laden
    let products = JSON.parse(localStorage.getItem('previewProducts') || '[]');

    previewArea.innerHTML = '';

    products.forEach((product, index) => {
      const div = document.createElement('div');
      div.className = 'preview-item';
      div.dataset.variantId = product.id; // WICHTIG: gültige Variant ID

      // Produktbild
      const img = document.createElement('img');
      img.src = product.image || '';
      img.className = 'preview-item-img'
      div.appendChild(img);

      // Titel
      // const title = document.createElement('div');
      // title.textContent = product.title || 'Produkt';
      // div.appendChild(title);

      // Entfernen Button
      const removeBtn = document.createElement('span');
      removeBtn.className = 'remove-btn'
      removeBtn.textContent = '×';
      removeBtn.addEventListener('click', () => {
        products.splice(index, 1);
        localStorage.setItem('previewProducts', JSON.stringify(products));
        renderPreview();
      });
      div.appendChild(removeBtn);

      previewArea.appendChild(div);
    });
  };
  
  // Funktion: speichern in localStorage
  const savePreview = () => {
    console.log("Saving products in preview to local storage.")
    localStorage.setItem('previewProducts', JSON.stringify(window.previewProducts));
  }

  document.querySelectorAll('.add-to-preview-form').forEach(form => {

      const button = form.querySelector('button');
      const originalText = button.textContent;

      form.addEventListener('submit', async (e) => {
          e.preventDefault();

          const productId = form.querySelector('input[name="add-to-preview-button-id"]').value;
          const productImg = (form.querySelector('input[name="add-to-preview-button-id"]')).getAttribute('data-product-image');
          const productTitle = (form.querySelector('input[name="add-to-preview-button-id"]')).getAttribute('data-product-title');

          let productDetails = {
              id: productId,
              title: productTitle,
              image: productImg
          }

          // Persistentes Array aus localStorage
          window.previewProducts = JSON.parse(localStorage.getItem('previewProducts')) || [];

          // Prüfen, ob Produkt schon vorhanden
          if (!window.previewProducts.find(p => p.id === productId)) {
              console.log( "Pushing product to preview: " + JSON.stringify(productDetails))
              window.previewProducts.push(productDetails);

              // Button Text kurzfristig ändern
              button.textContent = '✔ Hinzugefügt!';
              setTimeout(() => { button.textContent = originalText; }, 2000);              
          } else {
              // Button Text kurzfristig ändern
              button.textContent = '! Bereits vorhanden';
              setTimeout(() => { button.textContent = originalText; }, 2000);              
          }

          console.log( "Products in preview: " + JSON.stringify( window.previewProducts ));

          savePreview();
          renderPreview();
        });
  });

  // Vorschau beim Laden rendern
  renderPreview();

  // Drag & Drop
  if (typeof Sortable !== 'undefined') {
    new Sortable(previewArea, {
      animation: 150,
      ghostClass: 'sortable-ghost'
    });
  }
});
